/* eslint-disable no-promise-executor-return */
import React, { Dispatch, SetStateAction, useContext, useRef, useState } from "react";
import { Button } from "@mui/material";
import { SuccessAlertContext } from "App";
import { AxiosError } from "axios";
import Notify from "config/notify";
import CsvUploadModal from "./CsvUploadModal";
import uploadCsvApi from "../api/uploadCsvApi";
import { downloadFromUrl } from "../utils";

const limit = 10;

type Props = {
  isOpenCsvUpload: boolean; // マスタメンテナンスCSVモーダル立ち上げ
  setIsOpenCsvUpload: Dispatch<SetStateAction<boolean>>;
  isUploading: boolean;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  tableName: string | undefined;
  getMstOptions: Function;
};

/**
 * CSVアップロードボタン
 * @param root0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function CsvModals({
  isOpenCsvUpload = false,
  setIsOpenCsvUpload,
  isUploading,
  setIsUploading,
  tableName,
  getMstOptions,
}: Props) {
  const [isCheck, setIsCheck] = useState(false); // 確認画面かどうか
  const [file, setFile] = useState<File | null>(null);
  // const [isLoading, setIsLoading] = useState(false);
  const isFastLoading = useRef(false);

  const { showAlert } = useContext(SuccessAlertContext);

  const onClose = () => {
    setTimeout(() => {
      if (setIsOpenCsvUpload) setIsOpenCsvUpload(false);
      setIsCheck(false);
      setFile(null);
      setIsUploading(false);
      isFastLoading.current = false;
    }, 200);
  };

  // 発注確認画面へ
  const goPlaceOrderConfirm = async () => {
    if (!tableName) {
      showAlert("対象マスタを選択してください。", "error");
      return;
    }
    if (file) {
      setIsUploading(true);
      try {
        const csvData = await uploadCsvApi({
          table_name: tableName,
          csv_file: file,
        });
        if (csvData.isError) {
          downloadFromUrl(csvData.data.url, "マスタメンテナンス（エラー箇所付）");
          Notify.setNotification({
            show: true,
            title: "アップロードしたCSVにエラー箇所があります。",
            message: "詳細はダウンロードされたCSVをご確認ください。",
            titleColor: "var(--error)",
          });
          onClose();
        } else {
          getMstOptions(); // 最終更新日取得し直し
          onClose();
          showAlert("CSVをアップロードしました。");
        }
      } catch (err) {
        console.error(err);
        if (err) {
          const errData = (err as AxiosError).response?.data as any;
          if (errData.url) downloadFromUrl(errData.url, "マスタメンテナンス（エラー箇所付）");
        }
        showAlert("CSVのアップロードに失敗しました。", "error");
      } finally {
        setIsUploading(false);
      }
    } else {
      showAlert("予期せぬエラーが発生しました。", "error");
    }
  };

  return (
    <CsvUploadModal
      isOpenCsvUpload={isOpenCsvUpload}
      isCheck={isCheck}
      onClose={onClose}
      goConfirm={goPlaceOrderConfirm}
      file={file}
      title="マスタメンテナンスCSVアップロード"
      setFile={setFile}
      isLoading={isUploading}
    />
  );
}
